module.exports = __webpack_public_path__ + "img/mk2k.3d4ad413.png";